import React from "react";
import bodyClass from "../decorators/bodyClass";

import "../assets/customers/css/Spinner.scss";

const Spinner = () => (
  <div className="popup popup-spinner">
    <div className="spinner">
      <div className="rect1" />
      <div className="rect2" />
      <div className="rect3" />
      <div className="rect4" />
      <div className="rect5" />
    </div>
  </div>
);

export default bodyClass("overflow-hidden", { append: true })(Spinner);
